import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { DiagnosticData } from '../models/diagnostics';
import Table from 'react-bootstrap/Table';
import { DiagnosticsApi } from '../api/DiagnosticsApi';
import { IApiError, useErrorContext } from '../contexts/ErrorContext';
import LoadingPage from './util/LoadingPage';
import Utils from '../api/Utils';

const DiagnosticsPage = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [diagnosticData, setDiagnosticData] = useState<DiagnosticData[]>();
  const error = useErrorContext();

  const fetchDiagnostics = async () => {
    return await DiagnosticsApi.getDiagnostics();
  };
  useEffect(() => {
    fetchDiagnostics().then((data) => {
      if (!Utils.isError(data)) {
        setDiagnosticData(data as DiagnosticData[]);
      } else {
        const errorData = data as IApiError;
        error.setError(errorData.message);
        setDiagnosticData([]);
      }
      setDataLoaded(true);
    });
  }, []);

  if (!dataLoaded) {
    return <LoadingPage message={'Please Wait...'} />;
  }

  return (
    <Container>
      <h3 className='mt-3'>Diagnostics Page</h3>
      <Table striped bordered>
        <thead>
          <tr>
            <th>Module</th>
            <th>Test</th>
            <th>Passed</th>
            <th>Duration in Milliseconds</th>
            <th>Error Message</th>
          </tr>
        </thead>
        <tbody>
          {dataLoaded &&
            diagnosticData &&
            diagnosticData.map((d, idx) => (
              <tr key={`${d.moduleName}-${idx}`}>
                <td>{d.moduleName}</td>
                <td>{d.test}</td>
                <td>{d.passed ? 'Yes' : 'No'}</td>
                <td>{d.duration} ms</td>
                <td>{d.errorMessage ? d.errorMessage : 'N/A'}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default DiagnosticsPage;
